import * as React from "react"
import { connect } from 'react-redux'
import FileInputComponent from 'react-file-input-previews-base64'
import trans from "trans"
import store from "store"

import {
    Theme,
    Icon,
    confirm,
    Button,
    Message,
    Grid,
    GridCell
} from "@bdfx/mergado-ui-kit"

import { find } from "lodash"

import {
    GENERAL_ERROR,
    GENERAL_SUCCESS,
    GET_GRADIENTS,
    setGradientsToStore,
} from "template-edit/reducers";

import {createToast} from "actions";
import { AlternativeTemplate, Gradient, Template } from "app/types/model-types";
import {deleteGradient, exportGradients, getGradients, importGradients, projectId} from "app/helpers/api";
import toastFactory from "app/helpers/toast_factory";
import {GradientColorPicker} from "./gradient-color-picker";
import {GradientDefs, GradientFillUrl, GradientSvg} from "./fields";
import { ID, ReduxList } from "app/types/app-types"
import { initGradient } from "settings/components/gradients"
import { selectFormValues } from "app/reducers/form"
import { AxiosResponse } from "axios"
import { checkGradientsUsage, getFormName, GradientUsageType } from "./helpers"
import { FileInputType } from "template-list/containers/template-list"
import { ConfirmStyles } from "load_styles"

export const ALLOWED_FILE_TYPES = [
    "application/json",
    "text/plain",
]

export const MAX_FILE_SIZE = 10485760

interface Props {
    handleChangeGradient: Function
    gradientId: ID
    gradients: Gradient[]
    templates: ReduxList<Template>
    createToast: typeof createToast
    setGradientsToStore: typeof setGradientsToStore
}

interface State {
    isLoading: boolean
    showSelect: boolean
    gradientUsage: GradientUsageType[]
}

class SelectGradient extends React.Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            isLoading: false,
            showSelect: false,
            gradientUsage: [],
        }
    }

    componentDidMount() {
        this.updateGradients()
    }

    updateGradients = () => {
        this.setState({ isLoading: true })

        getGradients()
            .then((response: AxiosResponse<Gradient[]>) => {
                this.props.setGradientsToStore(response.data)
            })
            .catch(error => {
                store.dispatch(createToast(toastFactory(GET_GRADIENTS.ERROR, error)))
            })
            .finally(() => {
                this.setState({ isLoading: false })
            })

        this.setState({ gradientUsage: checkGradientsUsage(this.props.templates) })
    }

    handleResetGradient = () => {
        this.handleChangeGradient(null)
    }

    handleDeleteGradient = (gradient: Gradient) => {
        RemoveGradientConfirm(gradient, this.updateGradients)
    }

    handleChangeGradient = (gradient: Gradient) => {
        this.props.handleChangeGradient(gradient)
        this.setState({ showSelect: false })
    }

    importGradients = (file: FileInputType) => {
        if (file.size <= MAX_FILE_SIZE && ALLOWED_FILE_TYPES.includes(file.type)) {
            importGradients(file.base64, file.name)
                .then((response: AxiosResponse<Gradient[]>) => {
                    this.props.setGradientsToStore(response.data)
                })
                .catch(error => {
                    console.error('cannot import gradient', error)
                })
        } else {
            console.error(`Unsupported file: ${file.type}, size: ${file.size}`)
        }
    }

    render() {
        const { isLoading, showSelect } = this.state
        const { gradients, gradientId } = this.props

        const gradient = gradientId ? find(gradients, (g: Gradient) => {
            return g.id === parseInt(`${gradientId}`)
        }) : initGradient

        const idx = gradient?.id ?? 'main'

        return <>
            <GridCell className={'gradient-wrapper'} style={{ textAlign: 'center', alignSelf: 'center', position: 'relative' }} title={trans('gradient')}>

                <div className={'clickable select-gradient'} style={{ border: '1px solid #ddd', borderRadius: 4, height: '38px', lineHeight: '38px' }} onClick={() => this.setState({ showSelect: !showSelect })}>
                    {gradient?.id ?
                        <svg width={'100%'} height={'38px'} xmlns="http://www.w3.org/2000/svg" style={{ paddingBottom: '2px' }}>
                            <GradientDefs gradient={gradient} idx={idx} />
                            <rect
                                width="100%"
                                height="100%"
                                fill={GradientFillUrl(idx)}
                                fillOpacity={`${(gradient.opacity ?? 100) / 100}`}
                            />
                        </svg> :
                        <span>{trans('select_gradient')}</span>
                    }
                </div>

                <span style={{ position: 'absolute', right: '3px', top: '5px', cursor: 'pointer' }} onClick={() => this.handleResetGradient()}>
                    <Icon type={'close-light'} color={Theme.grey} title={trans('no_gradient')} size={18} />
                </span>
            </GridCell>

            {showSelect &&
                <GridCell col={'1/-1'}>
                    {(gradients && Array.isArray(gradients) && gradients.length > 0) ?
                        <Grid cols={'repeat(auto-fit, 62px)'} className={isLoading ? 'muk-helper-loading' : ''} style={{ marginTop: '5px' }}>
                            {gradients.map((gradient, key) => {
                                const isUsed = find(this.state.gradientUsage, (u: GradientUsageType) => {
                                    return `${u.gradientId}` === `${gradient.id}`
                                })

                                return <GridCell key={`gradient-${key}`} className={'centered'}>
                                    <div title={isUsed ? `${trans('gradient_is_used_by_template')} (${trans('template')} ${isUsed.templateId})` : undefined} className={`clickable`} onClick={() => this.handleChangeGradient(gradient)} style={{ position: 'relative' }}>
                                        <GradientSvg gradient={gradient} idx={gradient.id} width={68} height={68} isActive={gradientId === gradient.id} style={{ paddingTop: '7px' }} />
                                        {gradient.id && !isUsed &&
                                            <span style={{ position: 'absolute', right: '6px', top: '8px', cursor: 'pointer' }} onClick={() => this.handleDeleteGradient(gradient)}>
                                                <Icon type={'trash'} color={Theme.red} size={16} />
                                            </span>
                                        }

                                        <span title={trans('export_gradients')} style={{ position: 'absolute', left: '6px', top: '8px', cursor: 'pointer' }} onClick={() => handleExportGradients([gradient.id])}>
                                            <Icon type={'download-radix'} color={Theme.steelblue} size={18} />
                                        </span>
                                    </div>
                                </GridCell>
                            }
                            )}
                        </Grid> : <Message type={"info"} closeable={true} icon={<Icon type={'info'} color={Theme.blue} size={28} />}>
                            {trans('no_gradients_yet')}
                        </Message>
                    }

                    <div style={{marginBottom: '20px', marginTop: '-10px', textAlign: 'center'}}>
                    <FileInputComponent
                        labelText={null}
                        imagePreview={false}
                        multiple={false}
                        buttonComponent={
                            <Button
                                type={'void'}
                                secondary={true}
                                icon={<Icon type={'upload-radix'} text={trans("import_gradients")} color={Theme.steelblue} />}
                                text={trans('import_gradients')}
                            />
                        }
                        callbackFunction={this.importGradients}
                        accept="application/json"
                    />
                    </div>

                    <GradientColorPicker
                        updateGradients={this.updateGradients}
                        gradient={gradient}
                        key={gradient?.id || 'none'}
                        onSave={(updatedGradient) => this.handleChangeGradient(updatedGradient)}
                        gradients={gradients}
                    />
                </GridCell>
            }
        </>
    }
}

export const RemoveGradientMessage = (gradient: Gradient) => {
    return <Grid cols={'auto auto'} gap={'10px'}>
        <GridCell style={{alignSelf: 'center'}}>{trans('confirm_remove_gradient')}</GridCell>
        <GridCell><GradientSvg gradient={gradient} idx={gradient.id} width={100} height={100}/></GridCell>
    </Grid>
}

export const RemoveGradientConfirm = (gradient: Gradient, updateGradients: Function) => {
    return confirm({
        message: RemoveGradientMessage(gradient),
        style: ConfirmStyles,
        buttons: [
            <Button
                key="yes"
                color={Theme.red}
                onClick={() => {
                deleteGradient(gradient.id)
                    .then((response: any) => {
                        updateGradients()
                        store.dispatch(createToast(toastFactory(GENERAL_SUCCESS)))
                    })
                    .catch(error => {
                        console.error('cannot delete gradient', error)
                    })
            }}>{trans('yes')}</Button>,
            <Button
                key="no"
                color={Theme.green}
                onClick={() => false}
            >{trans('no')}</Button>]
    })
}

export const handleExportGradients = (gradientIds: ID[]) => {
    exportGradients(gradientIds)
        .then((response: AxiosResponse<Gradient[]>) => {
            const url = window.URL.createObjectURL(new Blob([JSON.stringify(response.data)]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `gradients_${projectId}_${gradientIds.join('-')}.json`);
            document.body.appendChild(link);
            link.click();
        })
        .catch(e => console.error('cannot export gradients', e))
}

function mapStateToProps(state) {
    return {
        gradients: state.gradients,
        templates: state.templates,
    }
}

export default connect(mapStateToProps, {
    createToast,
    setGradientsToStore,
})(SelectGradient)
